<div class="flex flex-col gap-2 rounded-lg border border-orange-200 bg-orange-50 p-3">
  <span class="text-sm">
    {{ 'ai.who-is' | translate: {term: mention().term} }}
  </span>

  <div class="flex flex-wrap gap-2">
    @for (candidate of mention().candidates; track candidate.type + '-' + candidate.id) {
      <elcia-button (onClick)="chosen.emit(candidate)"
                    [label]="candidate.fullName + ' · ' + ('ai.entity-type.' + candidate.type | translate)"
                    [severity]="'secondary'"
                    [size]="'small'"
                    [variant]="'outlined'"/>
    }
  </div>
</div>
